import { render, staticRenderFns } from "./15.vue?vue&type=template&id=bfaad6b8&"
import script from "./15.vue?vue&type=script&lang=js&"
export * from "./15.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports